import { config } from '../AuthConfig';
import { AuthChallenge } from './data/AuthChallenge';
import { PrimaryTokenTableEntry } from './data/AuthTypes';
import SecondaryTokenServiceBase from './SecondaryTokenServiceBase';

export default class OnPremSecondaryTokenService extends SecondaryTokenServiceBase {
	private static instance: OnPremSecondaryTokenService;

	static getInstance(): OnPremSecondaryTokenService {
		if (!OnPremSecondaryTokenService.instance) {
			OnPremSecondaryTokenService.instance = new OnPremSecondaryTokenService();
		}
		return OnPremSecondaryTokenService.instance;
	}

	private constructor() {
		super();
	}

	protected async getCachedPrimaryToken(
		_authChallenge: AuthChallenge,
		referenceUri: string,
		id: string
	): Promise<PrimaryTokenTableEntry> {
		return await this.tokenManager.getCachedPrimaryToken('', referenceUri, id);
	}

	protected getSecondaryTokenLifetime(): string {
		return config.secondaryTokenLifetimeOnPrem;
	}
}
